import React, {useState} from 'react';
import utils from "../services/utils";
import Captchaaptcha from "./Captcha";
import CooldownButton from "./CooldownButton";
import managedata from "../services/managedata";
import logosidebar from "../style/imges/logosidebar.png";

const ForgetPassComponent = (props) => {
    const [lorFname, setLorFname] = useState('');
    const [otpCode, setOTP] = useState(utils.useLang('OTCODE') + ' ' + utils.useLang('OTCODE_ASK'));
    const [password, setPassword] = useState(localStorage.getItem('pass'));
    const [frogetPassStep, setFrogetPassStep] = useState(1);
    const [msg, setMsg] = useState(utils.useLang('ERROR'));
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

    async function resetPassSend(dataInfo) {
        try {
            let data = {
                authentication: {
                    key: utils.getToken(),
                    businessToken: utils.getBusToken(),
                },
                data: dataInfo,
                type: {act: 'forgetPassword'}
            };
            return await managedata.sendData(data, false, 'sendBack')
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    }

    function finishReset() {
        setMsg(utils.useLang('CHANGED'));
        setFrogetPassStep(3);
    }

    const handleCompleteReset = () => {
        let data = {
            'data': {
                'phone': props.phoneNumber,
                "otpCode": otpCode,
            },
            'type': {'act': 'verifyNewPass'}
        }
        managedata.sendData(data, false, finishReset)
    }
    const handleReset = async () => {
        try {
            let data = {
                "phone": props.phoneNumber,
                "firstOrLastName": lorFname,
                "newPassword": password
            }
            const res = await resetPassSend(data)
            if (res) {
                if (res.debug.statusCode === 705) {
                    setMsg(utils.useLang('ACC_NOT_EXIST'))
                    setFrogetPassStep(3)
                } else setFrogetPassStep(2)
            }
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    }
    return (
        <div className="login-box reg-box">
            <img className={'logo-sidebar logo-reg'} src={logosidebar} alt="logo"/>
            <h2 className="login-title">{utils.useLang('FROGET_PASS')}</h2>
            {frogetPassStep === 1 && <div>
                <input
                    className="login-inp"
                    type="text"
                    placeholder={utils.useLang('PHONE_NUMBER')}
                    value={props.phoneNumber}
                    onChange={(e) => props.setPhoneNumber(e.target.value)}
                />
                <input
                    className={'login-inp'}
                    type="password"
                    placeholder={utils.useLang('NEW_PASS')}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <input
                    className={'login-inp'}
                    type="text"
                    id={'FirstLastName'}
                    placeholder={utils.useLang('F_OR_L_NAME')}
                    value={lorFname}
                    onChange={(e) => setLorFname(e.target.value)}
                />
                <Captchaaptcha onVerify={setIsCaptchaVerified}/>
                {isCaptchaVerified && <button className="login-btn" onClick={handleReset}>
                    {utils.useLang('RESET_PASS')}
                </button>}
            </div>}
            {frogetPassStep === 2 && <div>
                <input
                    className="login-inp"
                    type="text"
                    placeholder={utils.useLang('OTCODE')}
                    value={otpCode}
                    onChange={(e) => setOTP(e.target.value)}
                />
                <button className="login-btn" onClick={handleCompleteReset}>
                    {utils.useLang('SEND')}
                </button>
                <CooldownButton
                    label={utils.useLang('SEND_CODE_AGAIN')}
                    onClick={handleReset}
                />
            </div>}
            {frogetPassStep === 3 && <div>{msg}</div>}
            <button className="login-btn" onClick={() => props.setForgetPassMode(false)}>
                {utils.useLang('BACK')}
            </button>
        </div>
    );
};

export default ForgetPassComponent;